import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import { AccountResponse, FindAccountQuery, FindAccountQueryHandler } from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class AccountDataQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly findAccountQueryHandler: FindAccountQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.findAccountQueryHandler = new FindAccountQueryHandler(queryRepository);
  }

  public findAccount(): Promise<AccountResponse> {
    const query = {} as FindAccountQuery;
    return this.findAccountQueryHandler.handle(query);
  }
}
